const PERFORMANCE_ADD_DRAFT_KEY = 'PERFORMANCE_ADD_DRAFT'

export function savePerformanceDraft(payload) {
	if (!payload) {
		return
	}
	try {
		sessionStorage.setItem(PERFORMANCE_ADD_DRAFT_KEY, JSON.stringify(payload))
	} catch (e) {
		console.warn('保存业绩草稿失败', e)
	}
}

export function loadPerformanceDraft() {
	try {
		const raw = sessionStorage.getItem(PERFORMANCE_ADD_DRAFT_KEY)
		if (!raw) {
			return null
		}
		return JSON.parse(raw)
	} catch (e) {
		console.warn('读取业绩草稿失败', e)
		return null
	}
}

export function clearPerformanceDraft() {
	try {
		sessionStorage.removeItem(PERFORMANCE_ADD_DRAFT_KEY)
	} catch (e) {}
}

export default {
	savePerformanceDraft,
	loadPerformanceDraft,
	clearPerformanceDraft
}
